<template>
  <div class="batch-samples-sample-details">
    <div class="batch-samples-sample-details-data">
      <div class="batch-samples-sample-details-data-list">
        <div class="batch-samples-sample-details-data-list-item">
          <div class="batch-samples-sample-details-data-label">
            Lote:
          </div>

          <div class="batch-samples-sample-details-data-value">
            <div class="mnemonic-pill">
              {{ sample?.batch_label }}
            </div>
          </div>
        </div>

        <div class="batch-samples-sample-details-data-list-item">
          <div class="batch-samples-sample-details-data-label">
            Código:
          </div>

          <div class="batch-samples-sample-details-data-value">
            {{ sample?.bar_code }}
          </div>
        </div>

        <div class="batch-samples-sample-details-data-list-item">
          <div class="batch-samples-sample-details-data-label">
            Data:
          </div>

          <div class="batch-samples-sample-details-data-value">
            {{ sample?.date | date }}
          </div>
        </div>
      </div>

      <div class="batch-samples-sample-details-data-packaging">
        <div
          :class="[
            'batch-samples-sample-details-data-packaging-box',
            packaging?.colorClass
          ]"
        >
          <md-icon
            :md-src="packaging?.iconSrc"
            class="batch-samples-sample-details-data-packaging-icon"
          />
        </div>
      </div>
    </div>

    <template>
      <div class="batch-samples-sample-details-separator" />

      <footer>
        <md-button
          class="btn btn-nonenary"
          @click="handleContinue"
        >
          <md-icon
            md-src="/static/images/icon-batch-sample.svg"
            class="batch-samples-sample-details-footer-icon"
          />

          Lotear amostra
        </md-button>
      </footer>
    </template>
  </div>
</template>

<script>
import moment from 'moment'

import strings from '@/strings'

export default {
  name: 'BatchSamplesSampleDetails',
  filters: {
    date: (value) => moment(value).format('DD-MM-YYYY')
  },
  props: {
    sample: {
      required: true
    }
  },
  computed: {
    packaging() {
      let packaging = strings.packagingStatus.find(packaging => packaging.id === this.sample.packagingId)

      if (packaging) {
        packaging = {
          id: packaging.id,
          name: packaging.name,
          iconSrc: `/static/images/icon-${packaging.state}.svg`,
          colorClass: packaging.color
        }
      }

      return packaging
    }
  },
  methods: {
    handleContinue() {
      this.$emit('continue')
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-samples-sample-details {
  display: flex;
  flex-direction: column;
  min-width: 12.5rem;

  &-data {
    flex: 1;
    display: flex;
    gap: 1rem;
    color: #818181;

    &-list {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      &-item {
        display: flex;
        gap: 0.5rem;
      }
    }

    &-label {
      font-weight: 700;
      text-transform: uppercase;
      font-size: 0.75rem;
    }

    &-value {
      font-weight: 500;
      font-size: 0.75rem;
    }

    &-packaging {
      &-box {
        width: 1.75rem;
        height: 1.75rem;
        border-radius: 0.1875rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-icon {
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }

  &-separator {
    width: 100%;
    height: 1px;
    background-color: #CCCCCC;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .md-button {
    display: flex;
    width: 100%;
    gap: 0.5rem;
    align-items: center;
  }

  .mnemonic-pill {
    background-color: #404040;
    color: #FFFFFF;
    padding: 0.125rem 0.5rem;
    border-radius: 0.125rem;
    display: inline-flex;
  }
}
</style>
